<template>
  <div class="news-item-container">
    <div class="left">
      <div class="title-container">
        <a class="news-title" :href="data.url" target="_blank">{{data.title}}</a>
      </div>
      <!-- <div class="origin-title" v-if="data.OriginTitle">
        <div class="origin-title-icon">原文</div>
        <span class="origin-title-content">{{data.OriginTitle}}</span>
      </div> -->
      <div>
        <span class="date">{{data.date}}</span>
        <span class="source">{{data.source}}</span>
        <span v-if="data.count > 0" @click="onEmitNewsId(data.newsId)" class="related-news"><span class="related-news-icon"></span>{{data.count}}篇相关文章</span>
      </div>
      <div class="summary" v-if="data.summary">
        <div class="summary-content">{{data.summary}}</div>
      </div>
    </div>
    <div class="right" v-if="data.entities && data.entities.length">
      <div class="entities">
        <div v-for="(entity, key) in entities" :key="key">
          <entity-events :name="entity.name" :events="entity.events"></entity-events>        
        </div>
      </div>      
      <div v-if="data.entities && data.entities.length > defautCount" class="row operation" @click="toggleOperation">
        <span>{{operationText}}</span><i :class="operationIcon"></i>
      </div>
    </div>
    <div class="news-dialog">
      <el-dialog
        :visible.sync="dialogVisible"
        width="640"
        >
        <div class="news-dialog_title">相关新闻<span class="news-dialog_title-count">({{similarityTotalCount}}条)</span></div>
        <div class="news-list-box" v-loading="isLoading">
          <similarity-news-list-item v-for="(item, idx) in similarityResultData" :data="item" :key="idx"></similarity-news-list-item>
          <div class="no-data-container" v-if="!isLoading && !similarityTotalCount">
            <no-data></no-data>
          </div>
        </div>  
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EntityEvents from '@/components/news-monitor/EntityEvents';
import SimilarityNewsListItem from '@/components/news-monitor/SimilarityNewsListItem';
import QuestionQuery from '@/rest/questionQuery';
import NoData from '@/components/common/NoData';

export default {
  name: 'news-list-item',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      defautCount: 3,
      isEntitiesCollapsed: true,
      dialogVisible: false,
      similarityTotalCount: 0,
      similarityResultData: [],
      isLoading: false
    };
  },
  computed: {
    entities() {
      if (this.isEntitiesCollapsed) {
        return this.data.entities.slice(0, this.defautCount);
      } 
      return this.data.entities;
    },
    operationText() {
      if (this.isEntitiesCollapsed) {
        return '展开';
      }
      return '收起';
    },
    operationIcon() {
      if (this.isEntitiesCollapsed) {
        return 'el-icon-caret-bottom';
      }
      return 'el-icon-caret-top';
    }

  },
  methods: {
    toggleOperation() {
      this.isEntitiesCollapsed = !this.isEntitiesCollapsed;
    },
    onEmitNewsId(newsId) {
      // this.$emit('emitNewsId', newsId);
      this.dialogVisible = true;
      QuestionQuery.similarityNewsList(newsId).then(result => {
        this.similarityTotalCount = result.totalCount;
        this.similarityResultData = result.pageItems;
      });
    }
  },
  components: {
    EntityEvents,
    NoData,
    SimilarityNewsListItem
  }
};
</script>

<style lang="scss" scoped>
.news-item-container {
  padding: 16px;
  border-bottom: 1px solid #333138;
  // border-left: 1px solid #4E4A4D;
  // border-right: 1px solid #4E4A4D;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .left {
    width: 65%;
    .title-container {
      display: flex;
      align-items: center;
    }
    .summary {
      padding-top: 9px;
      padding-bottom: 2px;
      .summary-content {
        word-break: break-all;
        color: #ffffffb3;
        font-size: 12px;
        letter-spacing: 0.3px;
      }
    }
    .origin-title {
      margin-bottom:4px;
      .origin-title-icon {
        display: inline-block;
        vertical-align: top;
        width: 32px;
        height: 19px;
        padding:0 3px;
        margin-right:8px;
        border-radius: 2px;
        border: solid 1px rgba(255, 255, 255, 0.2);
        color: #b3b2b3;
        font-size: 12px;

      }
      .origin-title-content {
        color: rgba(255, 255, 255, 0.7);
        font-family: DIN-Regular;
        font-size: 16px;
      }
    }
    .date {
      font-family: DIN-Regular;
      font-size: 12px;
      color: #b3b2b3;
      margin-right: 16px;
    }

    .source {
      margin-right: 16px;
      font-size: 12px;
      color: #999;
     
    }
    .related-news-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right:2px;
      vertical-align: middle;
      background-image: url("../../assets/img/related-news.svg");
      background-size: cover;
    }
    .related-news {
      font-size: 12px;
      color: #45a8cc;
      cursor: pointer;
      &:hover {
        color:#3cbeed;
        font-weight: bold;
      }
      &:active {
        color: #45a8cc;
        font-weight: bold;
      }
    }

    .news-title {
      margin: 0 24px 8px 0;
      font-size: 18px;
      color: #f7f7f7;
      font-weight: 500;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }    
  }

  .right {
    width: 35%;
    margin-left: 24px;
    background-color: rgba(22, 20, 24, 0.4);
    border-radius: 6px;
    .entities {
      padding: 4px 8px;
    }
    .operation {
      justify-content: center;
      align-items: center;
      height: 36px;
      font-size: 14px;
      color: #ffffff60;
      border-top: solid 1px #3e3c42;
      cursor: pointer;
      &:hover {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        color: #ffffff;
        background-color: rgba(22, 20, 24, 0.6);
      }
      &:active {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        color: #ffffff;
        background-color: rgba(22, 20, 24, 0.7);
      }
    }
  }
  .news-dialog {
    &_title {
      height: 54px;
      line-height: 52px;
      padding-left: 20px;
      font-size: 18px;
      color: #fff;
      border-bottom: 1px solid #4E4A4D;
    }
    .news-list-box {
      height: 60vh;
      overflow-y: auto;
      .no-data-container {
        height: 500px;
      }
    }
    /deep/ .el-dialog__wrapper {
      // z-index: 9999 !important;
      background: rgba(38, 36, 43, 0.9);
      .el-dialog {
        width: 900px;
        position: relative;
        margin-top: 13vh !important;
        border-radius: 8px;
        border: solid 1px #3e393b;
        .el-dialog__header {
          position: absolute;
          top: 0;
          right: 0px;
          .el-dialog__headerbtn {
            width: 24px;
            height: 24px;
            top: 14px;
            background-color: #999999;
            border-radius: 50%;
            .el-dialog__close {
              color: #514d4f;
            }
            &:hover {
              width: 24px;
              height: 24px;
              background-color: #fff;
              border-radius: 50%;
            }
          }
        }
        .el-dialog__body {
          background: #423f43;
          padding: 0;
          .search-news-list-container {
            .filter {
              height: 54px;
              justify-content: center;
              span {
                display: none;
              }
              div{
                display: none;
              }
              border-bottom: 1px solid #4E4A4D;
              padding-bottom: 22px;
            }
            .result-container {
            height: 60vh;
            overflow-y: auto;
            margin-top: 0;
            // &::-webkit-scrollbar-track-piece {
            //   background-color: rgba(0, 0, 0, 0);
            //   border-left: 1px solid rgba(0, 0, 0, 0);
            // }
            // &::-webkit-scrollbar {
            //   width: 8px;
            //   height: 34px;
            // }
            // &::-webkit-scrollbar-thumb {
            //   background-color: #676366;
            //   background-clip: padding-box;
            //   min-height: 28px;
            // }
            // &::-webkit-scrollbar-thumb:hover {
            //   background-color: #999999;
            // }
              .news-list-header {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
.news-dialog {
  &_title {
    height: 54px;
    line-height: 52px;
    padding-left: 20px;
    font-size: 18px;
    color: #fff;
    border-bottom: 1px solid #4E4A4D;
  }
  &_title-count {
    margin-left: 4px;
    color: #999999;
  }
  .news-list-box {
    height: 60vh;
    overflow-y: auto;
    .no-data-container {
      height: 500px;
    }
  }
  /deep/ .el-dialog__wrapper {
    // z-index: 9999 !important;
    background: rgba(38, 36, 43, 0.9);
    .el-dialog {
      width: 640px;
      position: relative;
      margin-top: 13vh !important;
      border-radius: 8px;
      border: solid 1px #3e393b;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 14px;
          background-color: #999999;
          border-radius: 50%;
          .el-dialog__close {
            color: #514d4f;
          }
          &:hover {
            width: 24px;
            height: 24px;
            background-color: #fff;
            border-radius: 50%;
          }
        }
      }
      .el-dialog__body {
        background: #423f43;
        padding: 0;
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div{
              display: none;
            }
            border-bottom: 1px solid #4E4A4D;
            padding-bottom: 22px;
          }
          .result-container {
          height: 60vh;
          overflow-y: auto;
          margin-top: 0;
          // &::-webkit-scrollbar-track-piece {
          //   background-color: rgba(0, 0, 0, 0);
          //   border-left: 1px solid rgba(0, 0, 0, 0);
          // }
          // &::-webkit-scrollbar {
          //   width: 8px;
          //   height: 34px;
          // }
          // &::-webkit-scrollbar-thumb {
          //   background-color: #676366;
          //   background-clip: padding-box;
          //   min-height: 28px;
          // }
          // &::-webkit-scrollbar-thumb:hover {
          //   background-color: #999999;
          // }
            .news-list-header {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>

